import DatePicker from 'vue2-datepicker';
export default {
  name: 'rentalDetails',
  components: {
    DatePicker
  },
  props: ['editMode', 'masterAgreementApprovalStatus'],
  data() {
    return {
      vsetCode: null,
      uomClassObj: null,
      specIndex: null,
      showValueSetModal: false,
      parent_value_set_id: null,
      areaType: null,
      setTimeVsetCode: null,
      gridData: [
        {
          lease_master_agreement_hdr_id: null,
          lease_master_agreement_rental_id: 0,
          lease_rental_buffer_days: null,
          lease_rental_payment_term_id: null,
          lease_rental_period: null,
          lease_rental_period_uom_vset: null,
          lease_rental_period_uom_vset_meaning: null,
          lease_rental_start_from: null,
          payment_term_name: null,
          active: true
        }
      ],
      gridFields: [
        {
          key: 'add',
          stickyColumn: true
        },
        {
          key: 'remove',
          stickyColumn: true
        },
        {
          key: 'active',
          stickyColumn: true
        },
        {
          key: 'lease_rental_period_uom_vset_meaning',
          label: 'UOM'
        },
        {
          key: 'lease_rental_period',
          label: 'Rental Period'
        },
        {
          key: 'lease_rental_start_from',
          label: 'Rental Start From'
        },

        {
          key: 'lease_rental_buffer_days',
          label: 'Buffer Days'
        },
        {
          key: 'payment_term_name',
          label: 'Term'
        }
      ]
    };
  },
  mounted() {
    this.eventBus.$on('rd', leaseMasterAgreementHdrId => {
      if (leaseMasterAgreementHdrId) {
        this.getDetails(leaseMasterAgreementHdrId);
      }
    });
  },
  methods: {
    getDetails(leaseMasterAgreementHdrId) {
      const payload = {
        tabName: 'rental-details',
        leaseMasterAgreementHdrId: leaseMasterAgreementHdrId
      };
      this.loader = true;
      this.$store
        .dispatch('leases/getLeaseMasterAgreementDataById', payload)
        .then(resp => {
          this.loader = false;
          if (
            resp.status === 200 &&
            resp.data.data.length &&
            this.gridData[0].lease_master_agreement_rental_id === 0
          ) {
            this.gridData = resp.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addNewRow() {
      if (this.editMode) {
        this.gridData.push({
          lease_master_agreement_hdr_id: null,
          lease_master_agreement_rental_id: 0,
          lease_rental_buffer_days: null,
          lease_rental_payment_term_id: null,
          lease_rental_period: null,
          lease_rental_period_uom_vset: null,
          lease_rental_period_uom_vset_meaning: null,
          lease_rental_start_from: null,
          payment_term_name: null,
          active: true
        });
      }
    },
    opendDependentUom(vsetCode, index) {
      const payload = {
        valueSetName: vsetCode,
        dependentVariable: {
          user_id: this.$store.state.auth.userId,
          res_id: this.$store.state.shared.responsibilityId
        }
      };
      this.$store
        .dispatch('shared/getCommonVSetData', payload)
        .then(response => {
          this.loader = false;
          this.uomClassObj = null;
          if (response.status === 200) {
            const findTimeObj = response.data.data.page.find(
              vsetData => vsetData.value_code === 'TIME'
            );
            if (findTimeObj) {
              this.uomClassObj = findTimeObj;
              this.openValueSetModal('UOM', index);
            }
          }
        });
    },
    selectedvalueSet(item) {
      if (this.vsetCode === 'UOM') {
        this.gridData[this.specIndex].lease_rental_period_uom_vset =
          item.value_code;
        this.gridData[this.specIndex].lease_rental_period_uom_vset_meaning =
          item.value_meaning;
      } else if (this.vsetCode === 'FMS_PAYMENT_TERM') {
        this.gridData[this.specIndex].lease_rental_payment_term_id =
          item.payment_term_id;
        this.gridData[this.specIndex].payment_term_name =
          item.payment_term_name;
      }
      this.showValueSetModal = false;
    },
    openValueSetModal(vsetCode, index) {
      this.vsetCode = vsetCode;
      this.specIndex = index;
      this.showValueSetModal = true;
      this.parent_value_set_id = null;
      if (this.uomClassObj && vsetCode !== 'FMS_PAYMENT_TERM') {
        this.parent_value_set_id = this.uomClassObj.value_set_dtl_id;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    removeRow(index) {
      if (this.editMode) {
        this.gridData.splice(index, 1);
      }
    },
    checkUncheckRadio(specIndex) {
      this.gridData.forEach((element, index) => {
        return (element.active = index === specIndex ? true : false);
      });
    },
    clearVsetValues(vsetCode, index) {
      if (vsetCode === 'UOM_CLASS') {
        this.gridData[index].lease_rental_period_uom_vset = null;
        this.gridData[index].lease_rental_period_uom_vset_meaning = null;
      } else if (vsetCode === 'FMS_PAYMENT_TERM') {
        this.gridData[index].lease_rental_payment_term_id = null;
        this.gridData[index].payment_term_name = null;
      }
    }
  },
  beforeDestroy() {
    this.eventBus.$off('rd');
  }
};
